// Compatibility shim — kept so callers that import {TakePaymentDialog}
// keep working without changes. The real implementation lives in
// PaymentMethodModal.jsx (the new unified payment-method picker).
import { PaymentMethodModal } from './PaymentMethodModal';

export const TakePaymentDialog = PaymentMethodModal;
export default PaymentMethodModal;
